import {
  Progress,
  ProgressLabel,
  ProgressValue,
} from '@/components/ui/progress';

type WorkflowToastContentProps = {
  progress: number | null;
  label: string;
};

export function WorkflowToastContent({
  progress,
  label,
}: WorkflowToastContentProps) {
  if (progress === null) {
    return <span>{label}</span>;
  }

  return (
    <Progress value={progress} className="mt-1 min-w-56 gap-2">
      <ProgressLabel>{label}</ProgressLabel>
      <ProgressValue />
    </Progress>
  );
}
